module.exports = __webpack_public_path__ + "fepro/img/basketball.a634925d.png";